import {config, library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText} from '@fortawesome/vue-fontawesome'
import {
    faAngleDown, faArrowRight, faBars, faCalendar, faCamera, faCaretSquareDown, faCaretSquareUp, faCheck, 
    faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faCircle, faCircleInfo, faCircleNotch, 
    faCoins, faCreditCard, faExclamationTriangle, faExpand, faEyeSlash, faFileDownload, faFileInvoice, 
    faGrip, faHandHoldingHeart, faHashtag, faIdCard, faIndustry, faInfoCircle, faListUl, faLocationCrosshairs, 
    faMap, faMapLocationDot, faPaperPlane, faPen, faPlus, faPrint, faQuestionCircle, faSearch, faTimes, faTrash, faUser
} from '@fortawesome/free-solid-svg-icons'
import {
    faCalendar as faCalendarRegular
} from '@fortawesome/free-regular-svg-icons'
import {
    faPaypal as faPaypalBrand
} from '@fortawesome/free-brands-svg-icons'

// Explicit list instead of library.add(fas/far/fab): the three packs are 2051 icons and 1.31 MB of
// path data, of which this app renders 41. Every name below was resolved against the installed
// packs. An icon that is not registered renders empty without an error, so add new ones here as you
// use them rather than reaching back for a whole pack.
const icons = [
    faAngleDown, faArrowRight, faBars, faCalendar, faCamera, faCaretSquareDown, faCaretSquareUp, faCheck, 
    faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faCircle, faCircleInfo, faCircleNotch, 
    faCoins, faCreditCard, faExclamationTriangle, faExpand, faEyeSlash, faFileDownload, faFileInvoice, 
    faGrip, faHandHoldingHeart, faHashtag, faIdCard, faIndustry, faInfoCircle, faListUl, faLocationCrosshairs, 
    faMap, faMapLocationDot, faPaperPlane, faPen, faPlus, faPrint, faQuestionCircle, faSearch, faTimes, faTrash, faUser, faCalendarRegular, 
    faPaypalBrand,
]

// This is important, we are going to let Nuxt worry about the CSS
config.autoAddCss = false

library.add(...icons)

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.component('font-awesome-icon', FontAwesomeIcon, {})
    nuxtApp.vueApp.component('font-awesome-layers', FontAwesomeLayers, {})
    nuxtApp.vueApp.component('font-awesome-layers-text', FontAwesomeLayersText, {})
})
